/** Show search in filter option lists when option count exceeds this. */
export const FILTER_LIST_SEARCH_THRESHOLD = 6
